<mat-expansion-panel [expanded]="autoExpand" class="mat-elevation-z0">
    <mat-expansion-panel-header>
        <mat-panel-title class="bold">
            {{ 'common.labels.filters' | transloco }}
        </mat-panel-title>
    </mat-expansion-panel-header>
    <form [formGroup]="_filterForm" class="padding">
        <div class="flex-container">
            <mat-form-field class="form-field flex-item">
                <mat-label>{{ 'common.labels.invoiceNumber' | transloco }}</mat-label>
                <input matInput [formControlName]="'invoiceNumber'" [placeholder]="'common.labels.invoiceNumber' | transloco" />
            </mat-form-field>
        </div>
        <div class="flex-container">
            <mat-form-field class="form-field flex-item">
                <mat-label>{{ 'common.labels.dateOpenedFrom' | transloco }}</mat-label>
                <input matInput [matDatepicker]="dateOpenedFrom" [formControlName]="'dateOpenedFrom'"
                    [placeholder]="'common.labels.dateOpenedFrom' | transloco">
                <mat-datepicker-toggle matSuffix [for]="dateOpenedFrom"></mat-datepicker-toggle>
                <mat-datepicker #dateOpenedFrom></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="form-field flex-item">
                <mat-label>{{ 'common.labels.dateOpenedTo' | transloco }}</mat-label>
                <input matInput [matDatepicker]="dateOpenedTo" [formControlName]="'dateOpenedTo'"
                    [placeholder]="'common.labels.dateOpenedTo' | transloco">
                <mat-datepicker-toggle matSuffix [for]="dateOpenedTo"></mat-datepicker-toggle>
                <mat-datepicker #dateOpenedTo></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="flex-container">
            <mat-checkbox formControlName="isClosed" class="form-field flex-item">
                {{ 'common.labels.closed' | transloco }}
            </mat-checkbox>
            <mat-form-field class="form-field flex-item">
                <mat-label>{{ 'common.labels.dateClosedFrom' | transloco }}</mat-label>
                <input matInput [matDatepicker]="dateClosedFrom" [formControlName]="'dateClosedFrom'"
                    [placeholder]="'common.labels.dateClosedFrom' | transloco">
                <mat-datepicker-toggle matSuffix [for]="dateClosedFrom"></mat-datepicker-toggle>
                <mat-datepicker #dateClosedFrom></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="form-field flex-item">
                <mat-label>{{ 'common.labels.dateClosedTo' | transloco }}</mat-label>
                <input matInput [matDatepicker]="dateClosedTo" [formControlName]="'dateClosedTo'"
                    [placeholder]="'common.labels.dateClosedTo' | transloco">
                <mat-datepicker-toggle matSuffix [for]="dateClosedTo"></mat-datepicker-toggle>
                <mat-datepicker #dateClosedTo></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="flex-container">
            <mat-checkbox formControlName="isExported" class="form-field flex-item">
                {{ 'common.labels.exported' | transloco }}
            </mat-checkbox>
            <mat-form-field class="form-field flex-item">
                <mat-label>{{ 'common.labels.dateExportedFrom' | transloco }}</mat-label>
                <input matInput [matDatepicker]="dateExportedFrom" [formControlName]="'dateExportedFrom'"
                    [placeholder]="'common.labels.dateExportedFrom' | transloco">
                <mat-datepicker-toggle matSuffix [for]="dateExportedFrom"></mat-datepicker-toggle>
                <mat-datepicker #dateExportedFrom></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="form-field flex-item">
                <mat-label>{{ 'common.labels.dateExportedTo' | transloco }}</mat-label>
                <input matInput [matDatepicker]="dateExportedTo" [formControlName]="'dateExportedTo'"
                    [placeholder]="'common.labels.dateExportedTo' | transloco">
                <mat-datepicker-toggle matSuffix [for]="dateExportedTo"></mat-datepicker-toggle>
                <mat-datepicker #dateExportedTo></mat-datepicker>
            </mat-form-field>
        </div>
        <div class="flex-container">
            <mat-checkbox formControlName="isPaid" class="form-field flex-item">
                {{ 'common.labels.paid' | transloco }}
            </mat-checkbox>
            <mat-form-field class="form-field flex-item">
                <mat-label>{{ 'common.labels.datePaidFrom' | transloco }}</mat-label>
                <input matInput [matDatepicker]="datePaidFrom" [formControlName]="'datePaidFrom'"
                    [placeholder]="'common.labels.datePaidFrom' | transloco">
                <mat-datepicker-toggle matSuffix [for]="datePaidFrom"></mat-datepicker-toggle>
                <mat-datepicker #datePaidFrom></mat-datepicker>
            </mat-form-field>
            <mat-form-field class="form-field flex-item">
                <mat-label>{{ 'common.labels.datePaidTo' | transloco }}</mat-label>
                <input matInput [matDatepicker]="datePaidTo" [formControlName]="'datePaidTo'"
                    [placeholder]="'common.labels.datePaidTo' | transloco">
                <mat-datepicker-toggle matSuffix [for]="datePaidTo"></mat-datepicker-toggle>
                <mat-datepicker #datePaidTo></mat-datepicker>
            </mat-form-field>
        </div>
        <div>
            <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.clearFiltersButton' | transloco" type="button"
                (click)="onClear()" [disabled]="!_filterForm.dirty">
                {{ 'common.labels.clearFilters' | transloco }}
            </button>
            <button mat-raised-button color="accent" class="margin-sides-5" [attr.aria-label]="'common.labels.filterButton' | transloco" type="submit"
                (click)="onFilter()">
                {{ 'common.labels.filter' | transloco }}
            </button>
        </div>
    </form>
</mat-expansion-panel>